import Proxy from "./Proxy"

class AccountProxy extends Proxy {
  constructor(parameters = {}) {
    super("auth/users/me", parameters)
  }
}

export default AccountProxy
